import React, { useEffect } from "react";
import AddInputs from "../../../../components/Add/AddInputs";
import GeolocationComponent from "../../../../components/GeoLocation/GeolocationComponent";
import MainBusinessAssignedArea from "../../../../components/Add/BusinessAssignedArea/MainBusinessAssignedArea";
import CheckBoxWithTitle from "../../../../components/checkbox/CheckBoxWithTitle";
import Image from "../../../../components/images/Image";
import { useSelector } from "react-redux";
import { RootState } from "../../../../store";
import { useDispatch } from "react-redux";
import { updateMDDetails } from "../addMDSlice";
import { setCoordinates, setLocationInfo, setShowFields } from "../../../../store/slices/geolocationSlice";
// import { setEditedBusinessArea } from "../../../../store/slices/businessAreasSlice";
import { setPhoneNumber } from "../../../../store/slices/phoneNumbersSlice";
import { setProvinces, setRegion } from "../../../../store/slices/businessAreasSlice";

interface BasicDetailsProps {
  editLoading: boolean;
  addMDLoader?: Record<string, any>;
  disableAll: boolean;
  handleInputValues: (id: string, value: string) => void;
  addAdminDetails: Record<string, any>;
  handleVerify?: (id: string, resend: boolean) => void;
  felidError: any;
  errors: any;
  handleSubmitOTP: () => void;
  isOpenOtpModel: boolean;
  setIsOpenOtpModel: React.Dispatch<React.SetStateAction<boolean>>;
  id?: string;
  wallet_access: string[];
  handelCheckBox: (id: string, isChecked?: boolean) => void;
  inputCordinates: { latitude: number | null; longitude: number | null; },
  setInputCordinates: React.Dispatch<React.SetStateAction<any>>;
  type: string;
  emailEdited: boolean;
  selectedOption: string;
  is_api_user: boolean;
  handleApiToggle: () => void;
  enable_sms: boolean;
  handleEnableSmsToggle: () => void;
  whitelisted_ips: string[];
  handleIpChange: (index: number, value: string) => void;
  handleAddIp: () => void;
  handleRemoveIp: (index: number) => void;
  apiAccessError?: string;
  ipErrors?: string[];
}

export default function BasicDetails({
  editLoading,
  addMDLoader,
  disableAll,
  handleInputValues,
  addAdminDetails,
  handleVerify,
  felidError,
  errors,
  handleSubmitOTP,
  isOpenOtpModel,
  setIsOpenOtpModel,
  id,
  wallet_access,
  handelCheckBox,
  inputCordinates,
  setInputCordinates,
  emailEdited,
  type,
  selectedOption,
  is_api_user,
  handleApiToggle,
  enable_sms,
  handleEnableSmsToggle,
  whitelisted_ips,
  handleIpChange,
  handleAddIp,
  handleRemoveIp,
  apiAccessError,
  ipErrors = [],
}: BasicDetailsProps) {
  const { first_name } = addAdminDetails;
  const { user_id, savedData } = useSelector((state: RootState) => state.addMD);
  const dispatch = useDispatch()
  const inputs = {
    "": {
      "First Name": {
        required: true,
        disabled: false,
        id: "first_name",
        type: "input",
        maxLength: 50,
        tabIndex: 0,
      },
      "Last Name": {
        required: false,
        disabled: false,
        id: "last_name",
        type: "input",
        maxLength: 50,
        tabIndex: 1,
      },
      "Date of Birth": {
        required: true,
        disabled: false,
        id: "date_of_birth",
        type: "date",
        tabIndex: 2,
        disabledDate: true // Disable future dates for DOB
      },
      "Email Address": {
        required: false,
        disabled: (!first_name || (id && emailEdited)),
        id: "email_address",
        type: "input_verification",
        tabIndex: 4,
        validation: false,
        maxLength: 80,
      },
      "Phone Number": {
        required: true,
        disabled: !first_name,
        id: "phone_number",
        type: "phone_number",
        tabIndex: 3,
      },
      Gender: {
        id: "gender",
        type: "dropDown",
        required: true,
        disabled: false,
        noSearch: true,
        options: ["Male", "Female", "Undisclosed"],
        tabIndex: 5,
      },
      Nationality: {
        id: "nationality",
        type: "nationality",
        required: true,
        disabled: false,
        noSearch: false,
        tabIndex: 5,
      },
      Profession: {
        id: "profession",
        type: "dropDown",
        required: true,
        disabled: false,
        // noSearch: false,
        tabIndex: 2,
        options: [
          'Architect', 'Accountant', 'Electrician', 'Lawyer', 'Chef', 'Physician', 'Dentist', 'Butcher', 'Engineer', 'Designer',
          'Actor', 'Air Traffic Controller', 'Teacher', 'Dental Hygienist', 'Economist', 'Dietitians and Nutritionists',
          'Bartender', 'Barber', 'Soldier', 'Cashier', 'Bookkeeper', 'Businessperson', 'Firefighter', 'Librarian',
          'Police Officer', 'Registered Nurse', 'Pharmacist', 'Waiting Staff', 'Artist', 'Salesperson', 'Mail Carrier',
          'Secretary', 'Scientist', 'Bus Driver', 'Veterinarian', 'Journalist', 'Baker', 'Waste Collector', 'Bricklayer',
          'Tailor', 'Plumber', 'Farmer', 'Estate Agent', 'Lifeguard', 'Gardener', 'Automotive Service Technicians and Mechanics',
          'Optician', 'Hairdresser', 'Judge', 'Painter and Decorator', 'Florist', 'Housewife', 'Self-Employee'
        ],

      },
      multiPhoneNumber: {
        required: true,
        disabled: false,
        id: "multiPhoneNumber",
        type: "multiPhoneNumber",
        tabIndex: 0,
      },
      ...(selectedOption === "Corporate" && {
        "Recovery Email Address": {
          required: false,
          disabled: (!first_name || (id && emailEdited) || !addAdminDetails.email_address_verify),
          id: "recovery_email_address",
          type: "input_verification",
          tabIndex: 4,
          validation: false,
          maxLength: 80,
          loader: addMDLoader?.recovery_email_address
        },
      })
    },
    "Preferred Notification Language": {
      "Preferred Notification Language": {
        id: "notification_language",
        type: "dropDown",
        required: false,
        disabled: false,
        noSearch: true,
        options: ["English", "دری", "پشتو"],
        tabIndex: 6,
      },
    },
    "Residential Details": {
      "House No.": {
        required: false,
        disabled: false,
        id: "house_no",
        type: "input",
        maxLength: 60,
        tabIndex: 4,
      },
      "Market/Block No.": {
        required: false,
        disabled: false,
        id: "market_block_no",
        type: "input",
        tabIndex: 5,
        maxLength: 60,
      },
      "Floor No.": {
        required: false,
        disabled: false,
        id: "floor_no",
        type: "input",
        tabIndex: 6,
        maxLength: 60,
      },
      "Street Name": {
        required: false,
        disabled: false,
        id: "street_name",
        type: "input",
        tabIndex: 7,
        maxLength: 60,
      },
      Country: {
        required: false,
        disabled: false,
        id: "country",
        type: "country_type", // Adjust if needed
        tabIndex: 9,
      },
    },
  };

  useEffect(() => {
    if ((user_id || id)) {
      const data = {
        data: {
          basic_details: savedData['basic details']
        }
      }

      dispatch(updateMDDetails(data));
      const locationData = {
        latitude: savedData['basic details']?.latitude || undefined,
        longitude: savedData['basic details']?.longitude || undefined,
      };
      if (locationData.latitude && locationData.longitude) {
        dispatch(setCoordinates(locationData));
        dispatch(setLocationInfo(savedData['basic details']?.location_name));
        dispatch(setShowFields(true));
      }
      if (savedData['basic details']?.business_assigned_area?.region && savedData['basic details']?.business_assigned_area?.region !=='') {
        dispatch(setRegion(savedData['basic details']?.business_assigned_area?.region));
        dispatch(setProvinces(savedData['basic details']?.business_assigned_area?.provinces));
      }else{
        dispatch(setRegion(''))
        dispatch(setProvinces([]));
    }

      if (savedData['basic details']?.secondary_phone_numbers?.length > 0) {
        const formattedPhoneNumbers = savedData['basic details']?.secondary_phone_numbers.map((phone: any, index: number) => ({
          id: (index + 1).toString(),
          value: phone.country_code.split('+')[1] + phone.phone_number,
          isVerified: "true",
          countryCode: phone.country_code.split('+')[1],
          loading: false,
          error: ""
        }));
        dispatch(setPhoneNumber(formattedPhoneNumbers));
      }
    }
  }, [savedData])
  return (
    <>
      <AddInputs
        mapping={true}
        editLoading={editLoading}
        inputs={inputs}
        totalInputCount={7}
        verifyLoaders={addMDLoader}
        disableAll={disableAll}
        onInputChange={handleInputValues}
        inputValues={addAdminDetails}
        handleVerify={handleVerify}
        felidError={felidError}
        errors={errors}
        handleSubmitOTP={handleSubmitOTP}
        isDisabledField={id ? ["phone_number"] : []}
        isOpenOtpModel={isOpenOtpModel}
        setIsOpenOtpModel={setIsOpenOtpModel}
        edit={id ? true : false}
        RequiredPostalCode={true}
      />
      <GeolocationComponent inputCordinates={inputCordinates} setInputCordinates={setInputCordinates} />
      {type !== "Customers" && <MainBusinessAssignedArea />}
      <CheckBoxWithTitle
        title={"Wallet Access"}
        CheckBoxArray={["eTop Up", "Digital wallet"]}
        checkedArray={wallet_access}
        handelCheckBox={handelCheckBox}
        disabledCheckBox={
          editLoading ? ["eTop Up", "Digital wallet"] : ["Digital wallet"]
        }
        required={true}
        error={errors.wallet_access}
      />

      {/* API Access Section */}
      {type !== "Customers" && <div>
        <div className="flex pt-8 pb-4 gap-1">
          <h1 className="text-heading3 text-primary_text underline">API Access</h1>
        </div>

        <div className="bg-[#e5f0fc] rounded-[8px] p-2 mb-5">
          <p className="text-[14px] font-[500] leading-[22px] text-primary_text">
            Note: Enable API Access to configure SMS and IP Whitelisting. SMS is enabled by default and can be turned off manually.
          </p>
        </div>

        <div className="flex items-center gap-8 pl-1.5 pb-5">
          <div className="flex items-center gap-3">
            <button
              type="button"
              role="switch"
              aria-checked={is_api_user}
              disabled={editLoading}
              onClick={handleApiToggle}
              style={{
                display: 'inline-flex',
                alignItems: 'center',
                width: '50px',
                height: '26px',
                borderRadius: '28px',
                border: `2px solid ${is_api_user ? '#144ea2' : '#a4a9ae'}`,
                backgroundColor: is_api_user ? '#f0f5ff' : '#e5e9eb',
                position: 'relative',
                cursor: editLoading ? 'not-allowed' : 'pointer',
                transition: 'background-color 0.3s, border-color 0.3s',
                flexShrink: 0,
                padding: 0,
                opacity: editLoading ? 0.6 : 1,
                outline: 'none',
              }}
            >
              <span
                style={{
                  position: 'absolute',
                  top: '50%',
                  left: 0,
                  transform: `translateY(-50%) translateX(${is_api_user ? '26px' : '2px'})`,
                  width: '18px',
                  height: '18px',
                  borderRadius: '50%',
                  backgroundColor: is_api_user ? '#144ea2' : '#a4a9ae',
                  transition: 'transform 0.3s, background-color 0.3s',
                }}
              />
            </button>
            <span className="text-[14px] font-[400] leading-[22px] text-primary_text">
              Enable API Access
            </span>
          </div>

          <div className="flex items-center gap-3">
            <button
              type="button"
              role="switch"
              aria-checked={enable_sms}
              disabled={editLoading || !is_api_user}
              onClick={handleEnableSmsToggle}
              style={{
                display: 'inline-flex',
                alignItems: 'center',
                width: '50px',
                height: '26px',
                borderRadius: '28px',
                border: `2px solid ${enable_sms && is_api_user ? '#144ea2' : '#d1d4d7'}`,
                backgroundColor: enable_sms && is_api_user ? '#f0f5ff' : '#e5e9eb',
                position: 'relative',
                cursor: editLoading || !is_api_user ? 'not-allowed' : 'pointer',
                transition: 'background-color 0.3s, border-color 0.3s',
                flexShrink: 0,
                padding: 0,
                opacity: editLoading ? 0.6 : 1,
                outline: 'none',
              }}
            >
              <span
                style={{
                  position: 'absolute',
                  top: '50%',
                  left: 0,
                  transform: `translateY(-50%) translateX(${enable_sms && is_api_user ? '26px' : '2px'})`,
                  width: '18px',
                  height: '18px',
                  borderRadius: '50%',
                  backgroundColor: enable_sms && is_api_user ? '#144ea2' : '#d1d4d7',
                  transition: 'transform 0.3s, background-color 0.3s',
                }}
              />
            </button>
            <span className={`text-[14px] font-[400] leading-[22px] ${is_api_user ? 'text-primary_text' : 'text-secondary_text'}`}>
              Enable SMS
            </span>
          </div>
        </div>

        <div
          className={`rounded-[8px] p-4 flex flex-col gap-[10px] mb-5 ${is_api_user ? 'bg-background_blue' : 'bg-disable_fill'}`}
        >
          <span className={`text-[14px] font-[600] leading-[24px] ${is_api_user ? 'text-primary_text' : 'text-secondary_text'}`}>
            IP Whitelisting
          </span>
          {whitelisted_ips.map((ip, index) => (
            <div key={index} className="flex flex-col gap-1">
              <div className="flex items-center gap-2">
                <input
                  type="text"
                  value={ip}
                  onChange={(e) => handleIpChange(index, e.target.value)}
                  placeholder="Type IP addresses"
                  disabled={editLoading || !is_api_user}
                  className="flex-1 h-[56px] bg-white rounded-[8px] px-[15px] text-[16px] font-[500] leading-[24px] text-primary_text placeholder-secondary_text outline-none disabled:cursor-not-allowed"
                  style={{
                    border: `0.5px solid ${ipErrors[index] ? '#e53e3e' : is_api_user ? '#7294c7' : '#d1d4d7'}`,
                  }}
                />
                {whitelisted_ips.length > 1 && (
                  <button
                    type="button"
                    onClick={() => handleRemoveIp(index)}
                    disabled={editLoading || !is_api_user}
                    className="px-2 disabled:opacity-50"
                  >
                    <Image src={'delete_red'} className="cursor-pointer" />
                  </button>
                )}
              </div>
              {ipErrors[index] && (
                <p className="text-negative text-[12px] font-[400] leading-[18px] pl-1">
                  {ipErrors[index]}
                </p>
              )}
            </div>
          ))}
          {whitelisted_ips.length < 5 && (
            <button
              type="button"
              onClick={handleAddIp}
              disabled={editLoading || !is_api_user}
              className="flex items-center gap-2 text-[14px] font-[500] leading-[22px] disabled:opacity-50"
              style={{ color: is_api_user ? '#144ea2' : '#a4a9ae' }}
            >
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke={is_api_user ? '#144ea2' : '#a4a9ae'} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <line x1="12" y1="5" x2="12" y2="19" />
                <line x1="5" y1="12" x2="19" y2="12" />
              </svg>
              Add (You can add {4 - (whitelisted_ips.length - 1)} more IP addresses)
            </button>
          )}
          {apiAccessError && (
            <p className="text-negative text-[12px] font-[400] leading-[18px]">{apiAccessError}</p>
          )}
        </div>
      </div>}
    </>
  );
}
